/**
 * Jira-like comment thread on an HWCG incident task. Each post/reply is
 * appended to the tip and persisted via the same append-only version insert as
 * any other ticket field change.
 */

import React from 'react';
import { TicketSection } from './TicketSection';
import { ItemCommentsThread } from './ItemCommentsThread';
import type { TaskComment } from './actionTicketModel';

type TaskCommentsSectionProps = {
  value: TaskComment[];
  /**
   * Called with the full thread after a comment or reply is appended. The
   * drawer persists via `adapter.update` so each post is its own version.
   */
  onPost: (next: TaskComment[]) => void | Promise<void>;
  /** When set, the composer is disabled (past version being viewed). */
  readOnly?: boolean;
  currentUserGuid: string;
  currentUserName?: string;
};

export const TaskCommentsSection: React.FC<TaskCommentsSectionProps> = ({
  value,
  onPost,
  readOnly = false,
  currentUserGuid,
  currentUserName,
}) => (
  <TicketSection title="Comments" count={value.length || undefined}>
    <ItemCommentsThread
      value={value}
      onPost={onPost}
      readOnly={readOnly}
      currentUserGuid={currentUserGuid}
      currentUserName={currentUserName}
    />
  </TicketSection>
);

export default TaskCommentsSection;
